module.exports = __webpack_public_path__ + "img/音频播放器.ded05b90.png";